import React from 'react';

import Label from '../Label';

import { getObjectProps } from './helpers';

import styles from './TableExpandedList.module.scss';

export interface TableExpandedListProps {
  /** Expanded table content title. */
  title: string;
  /** Selected keys from the data. */
  selectProps: { key: string; accessor: string }[];
  /** Data rendered within the list. */
  rows: object;
}
export const TableExpandedList: React.FC<TableExpandedListProps> = ({
  title,
  selectProps,
  rows,
}) => {
  const filterData = getObjectProps(selectProps, rows);

  return (
    <div className={styles.expandedList}>
      <p className={styles.label}>{title}</p>
      <dl className={styles.list}>
        {Object.keys(filterData).map((key, i) => (
          // TODO: refactor out i
          <React.Fragment key={i}>
            <dt className={styles.title}>
              <Label noIcon>{key}</Label>
            </dt>
            <dd className={styles.details}>{filterData[key]}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
};

export default TableExpandedList;
export { styles };
